import isNumber from 'lodash/isNumber';
import get from 'lodash/get';
import { pageNames } from '~/constants/pageNames';
import { loanTypes } from '~/constants/loanTypes';
import { productType } from '~/lib/tealium/lookups';

const getApplicationEventForProcessing = (submitFrom) => {
  switch (submitFrom) {
    case pageNames.enterAmount:
      return '';
    default:
      return 'submitted';
  }
};

const getEventName = (state, piggyEvent) => {
  const eventType = piggyEvent.type;
  const eventComponent = piggyEvent.component;
  const eventName = piggyEvent.name;
  const onChangeType = 'onChange';
  const radioComponent = 'Radio';
  const loanAmountName = 'loanAmountIndex';

  const isLoanAmountRadioClick = eventType === onChangeType && eventComponent === radioComponent && eventName === loanAmountName;
  const offerId = get(state, 'displayData.globalData.offerId');
  const submitFrom = get(state, 'ui.submitFrom');

  const loanAmountIndex = get(piggyEvent, 'value');
  const selectedLoanOption = isNumber(loanAmountIndex) && get(state, `displayData.loanOffer.loanOptions[${loanAmountIndex}]`);
  const selectedAmount = get(selectedLoanOption, 'principal.amount');

  let productType_lookup = productType[offerId];
  return {
    enterAmount: {
      application_event: 'started',
      event_action: '',
      event_category: '',
      event_content: '',
      event_subcategory: '',
    },
    loanReview: {
      application_event: productType_lookup === loanTypes.immediate || productType_lookup === loanTypes.refill || isLoanAmountRadioClick ? '' : 'started',
      event_action: isLoanAmountRadioClick ? 'radio' : '',
      event_category: isLoanAmountRadioClick ? 'content' : '',
      event_content: isLoanAmountRadioClick ? `loan details: ${selectedAmount}` : '',
      event_subcategory: '',
    },
    processing: {
      application_event: getApplicationEventForProcessing(submitFrom),
      event_action: '',
      event_category: '',
      event_content: '',
      event_subcategory: '',
    },
    loanSuccess: {
      application_event: 'completed',
      event_action: '',
      event_category: '',
      event_content: '',
      event_subcategory: '',
    },
    errorPage: {
      application_event: '',
      event_action: 'application',
      event_category: 'error',
      event_content: 'technical error',
      event_subcategory: '',
    },
  };
};

const getEventData = (piggyEvent, state) => {
  const currentPage = get(piggyEvent, 'trackingPageName');
  return {
    ...get(getEventName(state, piggyEvent), currentPage),
  };
};

export default getEventData;
